import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'app-about-area',
  templateUrl: './about-area.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './about-area.component.scss'
})
export class AboutAreaComponent {
  @Input() title : string = "";
  @Input() subtitle : string = "";
  @Input() infoTitle : string = "";
  @Input() box1 : string = "";
  @Input() box2 : string = "";
  @Input() box3 : string = "";
  @Input() box4 : string = "";
  @Input() box5 : string = "";
  @Input() box6 : string = "";
  
}
